export default "/images/banner-faq-index.jpg";